import React from 'react'
import { View } from 'react-native'
import { Text, IconButton } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { createStyle } from '../../../../contexts/global-styles.provider'

const DEFAULT_TAG_COLOR = '#616161'

type CollaboratorListTagProps = {
  list: { name: string; color?: string | null }
  editable?: boolean
  onRemove?: () => void
}

export const CollaboratorListTag: React.FC<CollaboratorListTagProps> = ({
  list,
  editable = false,
  onRemove,
}) => {
  const { t } = useTranslation('nodes')
  const styles = useStyle()
  const backgroundColor = list.color || DEFAULT_TAG_COLOR

  return (
    <View style={[styles.tag, { backgroundColor }]}>
      <Text variant="bodySmall" style={styles.label} numberOfLines={1}>
        {list.name}
      </Text>
      {editable && onRemove && (
        <IconButton
          icon="close"
          size={10}
          iconColor="#FFFFFF"
          onPress={onRemove}
          style={styles.removeButton}
          accessibilityLabel={t('remove-list-tag')}
        />
      )}
    </View>
  )
}

const useStyle = createStyle(({ theme }) => ({
  tag: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    paddingVertical: 1,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(1.5),
    borderRadius: 999,
  },
  label: {
    color: '#FFFFFF',
    fontSize: 11,
    maxWidth: 160,
  },
  removeButton: {
    margin: 0,
  },
}))
